import React from 'react';
import { holdplanData } from '../data';
import SEO from '../components/SEO';

const holdplanSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "@id": "https://moonyoga-fredericia.dk/holdplan/#webpage",
  "url": "https://moonyoga-fredericia.dk/holdplan",
  "name": "Holdplan & booking af yogaklasser | Moon Yoga Fredericia",
  "description": "Se vores ugentlige holdplan og book din næste yogaklasse nemt via YOGO. Find tider for blid yoga, meditation og måneceremonier."
};

export default function Holdplan() {
  return (
    <div className="max-w-[1450px] mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 space-y-16">
      <SEO
        title="Holdplan & booking af yogaklasser | Moon Yoga Fredericia"
        description="Se vores ugentlige holdplan og book din næste yogaklasse nemt via YOGO. Find tider for blid yoga, meditation og måneceremonier i Fredericia."
        path="/holdplan"
        schema={holdplanSchema}
      />
      
      {/* Page Header */}
      <div className="text-center max-w-3xl mx-auto space-y-4">
        <span className="text-xs sm:text-sm tracking-[0.3em] uppercase text-brand-primary font-medium block">
          Find din klasse
        </span>
        <h1 className="font-serif text-4xl sm:text-5xl text-brand-primary font-semibold tracking-wide">
          {holdplanData.title}
        </h1>
        <p className="text-base sm:text-lg text-brand-muted leading-relaxed">
          {holdplanData.intro}
        </p>
        <div className="inline-block h-1 w-16 bg-brand-primary/30 rounded-full" />
      </div>

      {/* Description */}
      <div className="max-w-4xl mx-auto text-center">
        <p className="text-base sm:text-lg text-brand-text/90 leading-relaxed whitespace-pre-line">
          {holdplanData.description}
        </p>
      </div>

      {/* YOGO Calendar Section */}
      <section className="space-y-8">
        <div className="text-center space-y-2">
          <h2 className="font-serif text-2xl sm:text-3xl text-brand-primary font-semibold tracking-wide">
            Ugentlig Kalender
          </h2>
          <p className="text-sm text-brand-muted">
            Book din næste yogaklasse direkte i kalenderen nedenfor.
          </p>
        </div>

        {/* YOGO Container */}
        <div className="max-w-full mx-auto min-h-[400px] overflow-x-auto">
          <div className={`${holdplanData.yogo.calendarClass} w-full`} />
        </div>

        {/* Login Button */}
        <div className="text-center pt-2">
          <a
            href={holdplanData.yogo.loginUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-brand-primary hover:bg-brand-primary-hover text-white text-sm font-medium tracking-wide shadow-sm hover:shadow transition-all duration-300"
          >
            <i className="fa-solid fa-user-lock text-xs" />
            Log ind på din YOGO profil
          </a>
        </div>
      </section>

      {/* Practical Information Section */}
      <section className="max-w-4xl mx-auto space-y-8">
        <div className="text-center space-y-2">
          <h2 className="font-serif text-2xl sm:text-3xl text-brand-primary font-semibold tracking-wide">
            Praktisk Information
          </h2>
          <p className="text-sm text-brand-muted">
            Godt at vide, før du møder op i studiet.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          {holdplanData.practicalInfo.map((info, index) => (
            <div key={index} className="p-6 rounded-2xl bg-brand-surface border border-brand-primary/5 space-y-3">
              <h3 className="font-serif text-lg font-semibold text-brand-primary">
                {info.title}
              </h3>
              <p className="text-sm text-brand-muted leading-relaxed">
                {info.text}
              </p>
            </div>
          ))}
        </div>
      </section>

    </div>
  );
}
